import React, { FC } from 'react';

import { NotificationsReceiveOptions } from '../../../pages/notifications';
import Modal from '../Modal';
import { ModalProps } from '../Modal/Modal';

const NotificationModal: FC<ModalProps> = ({ active, onClose }) => {
  return (
    <Modal active={active} onClose={onClose}>
      <NotificationsReceiveOptions modalActive={active} />
    </Modal>
  );
};

export default NotificationModal;
